import React from 'react';
import styled from 'styled-components';
import { PropTypes } from 'prop-types';
import { H3 } from '../../style';

const Container = styled.a.attrs({ className: 'ui__list-item' })`
  border-top: ${(props) => props.theme.borders.default};
  border-bottom: ${(props) => props.theme.borders.default};
  margin-top: -1px;
  padding: ${(props) => props.theme.whitespace.small}
    ${(props) => props.theme.whitespace.base};
  display: flex;
  flex-direction: row;
  align-items: center;
  background: white;
  text-decoration: none !important;
  outline: none;

  ${(props) =>
    props.button &&
    `
    &:hover, &:focus {
      cursor: pointer;
      background: ${props.theme.colours.hover}
    }
  `};


  &:last-child {
    margin-bottom: -1px;
  }
`;
const Wrap = styled.div`
  flex: 1;
  padding: ${(props) =>
    `${props.theme.whitespace.base / 2} ${props.theme.whitespace.base}`};
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const PrimaryText = styled(H3)`
  color: ${(props) => props.theme.colours.link};
  font-weight: 500;
  margin: 0;
  &:last-child {
    margin-bottom: 0;
  }
`;
const SecondaryText = styled.div`
  ${(props) => props.theme.type.base};
  ${(props) => props.theme.type.small};
`;
const Addon = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
`;
const Label = styled.span`
  background: black;
  color: white;
  padding: ${(props) => props.theme.whitespace.xs}
    ${(props) => props.theme.whitespace.xs};
  line-height: 1em;
  display: inline-block;
  text-transform: uppercase;
  font-family: TheSunNarrow;
  font-weight: 900;
  margin: 0 ${(props) => props.theme.whitespace.small};
`;

const onKeyPress = (handler) => (e) => {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    handler();
  }
};

const ListItem = ({ primary, secondary, onClick, addon, button, isNew, className }) => (
  <Container
    onClick={onClick}
    button={button}
    onKeyPress={onKeyPress(onClick)}
    tabIndex="0"
    role="link"
    aria-label={primary}
    className={className}
  >
    <Wrap>
      <PrimaryText>{primary}</PrimaryText>
      {secondary && <SecondaryText>{secondary}</SecondaryText>}
    </Wrap>
    {isNew && <Label>New</Label>}
    <Addon>{addon}</Addon>
  </Container>
);
ListItem.propTypes = {
  primary: PropTypes.string.isRequired,
  secondary: PropTypes.string,
  className: PropTypes.string,
  addon: PropTypes.node,
  onClick: PropTypes.func,
  button: PropTypes.bool,
  isNew: PropTypes.bool
};
ListItem.defaultProps = {
  secondary: '',
  className: '',
  addon: '',
  onClick: () => {},
  button: false,
  isNew: false
};

export default ListItem;
